import * as React from 'react';
import { FixMeLater } from '../../utils';
import { PriceBlockContext } from './PriceBlockContext';
import { TypographyBodySize } from '../../theming';
import { TypographyBody, TypographyBodyProps } from '../Typography';
import { PriceBlockSize } from './PriceBlock.types';

export type PriceBlockWasAmountProps = TypographyBodyProps;

const sizeMap: { [key in PriceBlockSize]: TypographyBodySize } = {
    s: 's',
    m: 's',
    l: 'm',
};

export const PriceBlockWasAmount: React.ForwardRefExoticComponent<
    PriceBlockWasAmountProps & React.RefAttributes<HTMLElement>
> = React.forwardRef(function PriceBlockWasAmount(
    props: PriceBlockWasAmountProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { size: sizeProp = 'm' } = React.useContext(PriceBlockContext);
    const size = sizeMap[sizeProp];

    return (
        <TypographyBody
            ref={ref}
            component="div"
            size={size}
            lineHeight="1"
            weight="semiBold"
            color="text.light"
            lineThrough={true}
            {...props}
        />
    );
});
